
import { createFileRoute, Navigate, type SearchSchemaInput } from '@tanstack/react-router';
import { useApiQuery } from '../hooks/useApi';
import { useGetCollection } from '../hooks/collections/useCollections';
import type { ApiAttempt } from '../api/simulations.api';
import { attemptKeys } from '../hooks/attempts/useAttempts';
import SimulationCorrection from '../components/SimulationFlow/SimulationCorrection';
import Loader from '../components/Loader/Loader';
import GeneralError from '../components/Errors/General';

export const Route = createFileRoute('/simulazioni/$id_/correzione')({
  validateSearch: (search: { from?: string } & SearchSchemaInput): { from: string } => ({
    from: search.from ?? 'simulazioni',
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { from } = Route.useSearch();
  const backPath = `/${from}`;

  const { data: attempt, isFetching: isFetchingAttempt, error: attemptError } = useApiQuery<ApiAttempt>(
    `/attempts/${id}`,
    attemptKeys.detail(id),
    undefined,
    { enabled: !!id, staleTime: 60000, gcTime: 60000 },
  );

  const collectionId = attempt?.collectionId ?? '';
  const { collection, isFetching: isFetchingCollection } = useGetCollection(collectionId);

  if (isFetchingAttempt || (collectionId && isFetchingCollection && !collection)) return <Loader fullScreen />;
  if (attemptError || !attempt) return <GeneralError />;
  if (!collection) return <GeneralError />;
  if (collection.enableCorrection === false) return <Navigate to={backPath} replace />;

  return (
    <SimulationCorrection
      attempt={attempt}
      collection={collection}
      backPath={backPath}
    />
  );
}
